module.exports = __webpack_public_path__ + "img/backroll_pc.d6255e3d.png";